<mat-toolbar>
  <div class="toolbar-content">
    <div id="title-container">
      @if (isExtraSmall() || !mainNavService.mainNavOpen()) {
        <img
          id="thrive-logo-icon"
          ngSrc="assets/images/thrive-icon-logo-small.webp"
          width="43"
          height="43"
          class="only-on-light"
          alt="Thrive Mental Wellbeing"
          priority />
      }
      @if (isExtraSmall() || !mainNavService.mainNavOpen()) {
        <img
          id="thrive-logo-icon"
          ngSrc="assets/images/thrive-icon-logo-small-white.webp"
          width="43"
          height="43"
          class="only-on-dark"
          alt="Thrive Mental Wellbeing"
          priority />
      }
      @if (
        (!isMobile() && mainNavService.mainNavOpen()) ||
        (breakpointService.isMatched('sm') && mainNavService.mainNavOpen())
      ) {
        <img
          id="thrive-logo-full"
          class="only-on-light"
          ngSrc="assets/images/thrive-mental-wellbeing-logo-small.webp"
          width="116"
          height="43"
          alt="Thrive Mental Wellbeing"
          priority />
      }
      @if (
        (!isMobile() && mainNavService.mainNavOpen()) ||
        (breakpointService.isMatched('sm') && mainNavService.mainNavOpen())
      ) {
        <img
          id="thrive-logo-full"
          class="only-on-dark"
          ngSrc="assets/images/thrive-mental-wellbeing-logo-small-white.webp"
          width="116"
          height="43"
          alt="Thrive Mental Wellbeing"
          priority />
      }

      <mat-divider [vertical]="true" class="notification-divider" />

      <div id="region-flag">
        <div class="flag">
          <img
            width="86"
            height="43"
            [ngSrc]="'assets/images/flags/' + (isAustralia ? 'au' : 'gb') + '.webp'"
            alt="{{ isAustralia ? 'AUS' : 'UK' }}"
            priority />
        </div>

        <div class="app-name">
          <p>{{ title }}</p>
          <p class="region-name">{{ isAustralia ? 'Australia' : 'UK' }}</p>
        </div>
      </div>

      @if (featureFlagService.featureFlags()?.isThrive24Enabled) {
        <mat-divider *appUserHasScope="'region-settings:view'" [vertical]="true" class="notification-divider" />
        <app-office-hours *appUserHasScope="'region-settings:view'" />
      }

      <mat-divider *appUserHasScope="'chat:view-active-chats'" [vertical]="true" class="notification-divider" />

      <app-therapist-status *appUserHasScope="'chat:view-active-chats'" />

      @if (
        !featureFlagService.featureFlags()?.isThrive24Enabled &&
        !featureFlagService.featureFlags()?.isTherapistOnlineStatusEnabled
      ) {
        <ng-template [ngTemplateOutlet]="mobileBurgerMenu" />
      }
    </div>

    <div class="notification-area">
      @if (
        featureFlagService.featureFlags()?.isThrive24Enabled &&
        featureFlagService.featureFlags()?.isTherapistOnlineStatusEnabled
      ) {
        <ng-template [ngTemplateOutlet]="mobileBurgerMenu" />
      }

      <div *appUserHasScope="'chat:view-active-chats'" class="chat-version-row">
        <div class="version-text">V1</div>
        <app-failed-messages-button />
        <app-message-notification-button />
        <app-primary-notification-button />

        <mat-divider [vertical]="true" class="notification-divider" />

        <!-- go-chat-duplication start -->
        <div class="version-text">V2</div>
        <app-go-message-notification-button />
        <app-go-primary-notification-button />
        <!-- go-chat-duplication end -->
      </div>
    </div>
  </div>
</mat-toolbar>

<ng-template #mobileBurgerMenu>
  @if (isMobile()) {
    <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="toggleDrawer.emit()">
      <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
    </button>
  }
</ng-template>
